/* @flow */
import React from 'react';
import { range } from 'lodash';

import DateConstants from 'constants/DateConstants';
import Select from 'components/Select.jsx';

import './styles/BirthdateSelector.scss';

class BirthdateSelector extends React.Component {
  props: {
    onChange: Function,
    initialDate?: ?Date,
  }

  state: {
    year: ?number,
    month: ?number,
    day: ?number,
  }

  state = {
    year: this.props.initialDate ? this.props.initialDate.getFullYear() : null,
    month: this.props.initialDate ? this.props.initialDate.getMonth() + 1 : null,
    day: this.props.initialDate ? this.props.initialDate.getDate() : null,
  };

  calculateBirthdate = () => {
    // Setting default values to 0 to satisfy flow typing
    const year = this.state.year || 0;
    const month = this.state.month || 0;
    const day = this.state.day || 0;
    const isValid = year !== 0 && month !== 0 && day !== 0;

    if (isValid) {
      this.props.onChange(
        new Date(year, month - 1, day)
      );
    }
  }

  dayChanged = (value: string) => {
    this.setState({ day: parseInt(value, 10) }, this.calculateBirthdate);
  }

  monthChanged = (value: string) => {
    const month = parseInt(value, 10);
    this.setState({ month }, () => {
      // return number of days in a month
      const days = new Date(this.state.year || 0, month, 0).getDate();

      if (this.state.day && this.state.day > days) {
        this.setState({ day: days }, this.calculateBirthdate);
      } else {
        this.calculateBirthdate();
      }
    });
  }

  yearChanged = (value: string) => {
    this.setState({ year: parseInt(value, 10) }, this.calculateBirthdate);
  }

  render() {
    const monthOptions = range(0, 12).map(n => ({
      label: DateConstants.MONTHS[n],
      value: n + 1,
    }));

    // return number of days in a month
    const days = new Date(this.state.year || 0, this.state.month || 0, 0).getDate();
    const dayOptions = range(1, days + 1).map(n => ({
      label: n,
      value: n,
    }));

    const currentYear = new Date().getFullYear();
    const yearOptions = range(currentYear - 120, currentYear + 1).reverse().map(n => ({
      label: n,
      value: n,
    }));

    return (
      <div className="BirthdateSelector">
        <div className="BirthdateSelector-Select">
          <Select
            className="BirthdateSelector-Select-Month bday-month"
            options={monthOptions}
            autoComplete="bday-month"
            placeholder="Month"
            value={this.state.month}
            onChange={this.monthChanged}
          />
        </div>

        <div className="BirthdateSelector-Select">
          <Select
            options={dayOptions}
            key={this.state.day}
            className="BirthdateSelector-Select-Day bday-day"
            autoComplete="bday-day"
            placeholder="Day"
            value={this.state.day}
            onChange={this.dayChanged}
          />
        </div>

        <div className="BirthdateSelector-Select">
          <Select
            options={yearOptions}
            className="BirthdateSelector-Select-Year bday-year"
            autoComplete="bday-year"
            placeholder="Year"
            value={this.state.year}
            onChange={this.yearChanged}
          />
        </div>
      </div>
    );
  }
}

export default BirthdateSelector;



// WEBPACK FOOTER //
// ./src/chat/components/BirthdateSelector.jsx